import { constants, mediaQueryStyles } from "@newsela/angelou";

import { CONTENT_LAYOUT } from "@/view/ContentLayout/ContentLayout.style";
import { ACTIONS_TOOLBAR_HEIGHT } from "@/view/ActionsToolbar/ActionsToolbar.style";
import type { CSSObject } from "@emotion/react";
const { mediaQuery } = mediaQueryStyles;
const { colors, breakpoints } = constants;
const { xs, md } = breakpoints.BreakpointNames;
const TRANSPARENT = "transparent";

export const wrapperCss = {
  height: "100%",
};

export const panelCss = (
  isPanelVisible: boolean,
  isVideoPresentModeActive: boolean = false,
) => ({
  display: isPanelVisible ? "block" : "none",
  height: "100%",

  [mediaQuery.downTo(md)]: {
    height: isVideoPresentModeActive
      ? "calc(100vh)"
      : `calc(100vh - ${CONTENT_LAYOUT.STICKY_THRESHOLD})`,
    backgroundColor: TRANSPARENT,
  },
});

export const containerCss: CSSObject = {
  backgroundColor: colors.ui.white[500],
  border: 0,
  height: "100%",
  position: "relative",
  left: 0,
  width: "100%",

  [mediaQuery.between(xs, md)]: {
    borderRadius: "12px 12px 0 0",
  },

  [mediaQuery.downTo(md)]: {
    height: "100%",
    border: `1px solid ${colors.ui.neutral[100]}`,
    borderRadius: 0,
    borderWidth: "0 0 0 1px",
  },
};

export const focusContainerCss: CSSObject = {
  height: "100%",
  overflowY: "auto",

  [mediaQuery.downTo(md)]: {
    paddingBottom: ACTIONS_TOOLBAR_HEIGHT,
  },
};

// Styles for individual activity panels

export const panelWrapperCss = {
  display: "flex",
  flexDirection: "column",
  minHeight: "min-content",
};

export const scrollContainerCss = {
  flex: 1,
  minHeight: "min-content",
  overflowY: "overlay",
};
